import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { Text, Flex, Heading, mediaMixin } from '@zillow/constellation';
const stackedCSS = css`
    flex-direction: column;
    text-align: center;
`;
const StyledImageAndDescription = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: row;
    ${mediaMixin('lg', stackedCSS)};
`;
const StyledDescription = styled(Flex)`
    width: 100%;
`;
const ImageAndDescription = ({ Image, description, title }) => (
    <StyledImageAndDescription>
        <Image height="120" width="120" aria-hidden="true" />
        <StyledDescription display="flex" flexDirection="column">
            <Heading level="5" fontFamily="serif">
                {title}
            </Heading>
            <Text>{description}</Text>
        </StyledDescription>
    </StyledImageAndDescription>
);

ImageAndDescription.propTypes = {
    Image: PropTypes.elementType,
    description: PropTypes.string,
    title: PropTypes.string,
};
export { StyledImageAndDescription };
export default ImageAndDescription;
